module.exports = __webpack_public_path__ + "b57562204e4d45f473e67029ab42d268.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-64.cur
// module id = 470
// module chunks = 0